import { render, staticRenderFns } from "./ReportCheckListWorkPackage.vue?vue&type=template&id=066877b1&scoped=true&"
import script from "./ReportCheckListWorkPackage.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListWorkPackage.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListWorkPackage.vue?vue&type=style&index=0&id=066877b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066877b1",
  null
  
)

export default component.exports
import {QTooltip,QBtn} from 'quasar'
component.options.components = Object.assign({QTooltip,QBtn}, component.options.components || {})
